export default {
  "path": "/demo/detail-container",
  "meta": {
    "name": "demo-详情容器",
    "title": "Container 详情容器",
    "isComponentDoc": true,
    "category": "Data"
  }
};